<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useUserDialogStore } from '../store/dialog';

import DialogUserSign from '@/entities/User/components/dialog-user-sign.vue';
import DialogUserForgetPassword from '@/entities/User/components/dialog-user-forget-password.vue';
import DialogUserRecoveryPassword from '@/entities/User/components/dialog-user-recovery-password.vue';

const userDialogStore = useUserDialogStore();
const { dialog } = storeToRefs(userDialogStore);
</script>

<template>
	<dialog-user-sign v-model="dialog.sign" />
	<dialog-user-forget-password v-model="dialog.password" />
	<dialog-user-recovery-password v-model="dialog.recoveryPassword" />
</template>
